import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { Button as MuiButton } from '@mui/material';

/**
 * @template C
 * @typedef {C extends React.ComponentType<infer P> ? P : {}} PropsOf
 */

/**
 * @template C
 * @typedef {C extends React.ComponentType<{ ref: infer R }> ? R : never} RefOf
 */

/**
 * Turns an MUI button component into one which acts as a React Router link.
 *
 * Pass the desired button type to the `component` prop. By default this is a
 *  plain MUI `<Button>`.
 */
export default forwardRef(
    /**
     * @template C
     * @param {import('react-router-dom').LinkProps & { component?: C } & PropsOf<C>} props
     * @param {RefOf<C>} ref
     */
    function LinkButton(props, ref) {
        const {
            component: Button = MuiButton,
            href,
            to,
            ...other
        } = props;

        // Convert to router link if url given
        const linkProps = !!(href || to) && {
            component: Link,
            to: to ?? href,
        };

        return (
            <Button
                {...linkProps}
                {...other}
                ref={ref}
            />
        );
    }
);